<script lang="ts" setup>
const { t: $t } = useI18n()

const props = defineProps<{
  payload: { machineryId: string, isForeignMachineryDefect: boolean }
}>()
const emit = defineEmits<{ (e: 'close'): void }>()

const { $trpc, queryClient, useMutation, makeTrpcErrorToast } = useMutationHelpers()
const notification = useNotification()

const createDefect = useMutation({
  mutationFn: $trpc.customerModule.defect.publicCreate.mutate,
  onError: makeTrpcErrorToast(notification, { description: $t('customerModule.defect.notification.create.error') }),
  onSuccess: async () => {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: [CUSTOMER_MODULE_QUERY_KEY, 'defects', 'getById'] }),
      queryClient.invalidateQueries({ queryKey: [CUSTOMER_MODULE_QUERY_KEY, 'defects', 'getAllByEntityId'] }),
    ])
    notification.success({ title: $t('customerModule.defect.notification.create.success'), duration: 4500 })
    emit('close')
  },
})
</script>

<template>
  <CustomerModulePopup
    show
    :title="$t('customerModule.defect.createPublicPopUp.title', { machineryId: props.payload.machineryId })"
    :is-spinning="createDefect.isPending.value"
    @close="emit('close')"
  >
    <FormKit
      type="form" @submit="createDefect.mutate({
        machineryId: props.payload.machineryId,
        isForeignMachineryDefect: props.payload.isForeignMachineryDefect,
        ...$event },
      )"
    >
      <FormKit
        name="description"
        :label="$t('customerModule.defect.description.label')"
        type="text"
        validation="required"
      />
      <h2 class="font-bold text-base mt-6 mb-2">
        {{ $t('customerModule.defect.createPublicPopUp.contactInformation') }}
      </h2>
      <div class="flex flex-col md:flex-row gap-x-4">
        <FormKit
          name="contactPersonName"
          :label="$t('customerModule.defect.alternativeContactPersonName.label')"
          type="text"
          validation="required"
        />
        <FormKit
          name="contactPersonEmail"
          :label="$t('customerModule.user.email.label')"
          type="email"
          validation="required"
        />
        <FormKit
          name="contactPersonPhone"
          :label="$t('customerModule.defect.alternativeContactPersonPhone.label')"
          type="tel"
          validation="required|matches:/^\+?[0-9 /-]+$/"
        />
      </div>
    </FormKit>
  </CustomerModulePopup>
</template>
